


import { Component, Prop, Vue } from "vue-property-decorator";

import { Subscription } from "App/Models";

import Tab from "Web/Components/Tabs/Tab.vue";
import Tabs from "Web/Components/Tabs/Index.vue";
import QuotaLines from "./QuotaLines.vue";

@Component({
    components: {
        QuotaLines,
        Tab,
        Tabs
    }
})
export default class QuotaCard extends Vue {
    @Prop()
    Record?: Subscription;
}
